module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "chart-container"
  }, [_c('div', {
    staticClass: " ml30 mr30"
  }, [_c('div', {
    staticClass: " mb15 row flex-start"
  }, [_c('div', {
    staticClass: "row flex-start"
  }, [_c('div', [_vm._v("场地名称：")]), _vm._v(" "), _c('el-select', {
    ref: "selectValue1",
    staticClass: "mr25",
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.optionValueChange
    },
    model: {
      value: (_vm.optionValue),
      callback: function($$v) {
        _vm.optionValue = $$v
      },
      expression: "optionValue"
    }
  }, _vm._l((_vm.optionList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row flex-between mt15 mb15"
  }, [_c('div', {
    staticClass: "row flex-start"
  }, [_c('div', {
    staticClass: " row flex-center font24 grey6_text cursorp white_bg mr15",
    staticStyle: {
      "width": "180px",
      "height": "60px",
      "border": "1px solid rgba(227, 232, 238, 1)"
    },
    on: {
      "click": function($event) {
        return _vm.onEdit('new')
      }
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('div', {
    staticClass: " row flex-center font24 grey6_text cursorp white_bg mr15",
    staticStyle: {
      "width": "180px",
      "height": "60px",
      "border": "1px solid rgba(227, 232, 238, 1)"
    },
    on: {
      "click": function($event) {
        return _vm.onEdit()
      }
    }
  }, [_vm._v("编辑")]), _vm._v(" "), _c('div', {
    staticClass: " row flex-center font24 grey6_text cursorp white_bg mr15",
    staticStyle: {
      "width": "180px",
      "height": "60px",
      "border": "1px solid rgba(227, 232, 238, 1)"
    },
    on: {
      "click": function($event) {
        return _vm.editFuc('ENABLE')
      }
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('div', {
    staticClass: " row flex-center font24 grey6_text cursorp white_bg mr15",
    staticStyle: {
      "width": "180px",
      "height": "60px",
      "border": "1px solid rgba(227, 232, 238, 1)"
    },
    on: {
      "click": function($event) {
        return _vm.editFuc('DISABLE')
      }
    }
  }, [_vm._v("禁用")])])]), _vm._v(" "), [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    attrs: {
      "element-loading-background": "rgba(255, 255, 255, .5)",
      "element-loading-text": _vm.loadText,
      "element-loading-spinner": "el-icon-loading",
      "height": _vm.recoData.recParams.page_size == 10 ? 570 : 570,
      "data": _vm.recoData.list,
      "id": "ExportExcelTable",
      "row-style": _vm.rowStyle
    },
    on: {
      "row-click": _vm.changeCurrentRow
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "PlateNo",
      "width": "120",
      "label": "车号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "VehicleWeight",
      "label": "车辆皮重"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Driver",
      "label": "驾驶员"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "DriverPhone",
      "width": "120",
      "label": "驾驶员手机"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "customer",
      "label": "所属客户"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "begindate",
      "width": "180",
      "label": "有效期开始日期"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "enddate",
      "width": "180",
      "label": "有效期结束日期"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Comment",
      "label": "备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Valid",
      "label": "启用/禁用"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.Valid == 1) ? _c('span', {
          staticClass: "green_text"
        }, [_vm._v("已启用")]) : _vm._e(), _vm._v(" "), (scope.row.Valid == 0) ? _c('span', {
          staticClass: "red_text"
        }, [_vm._v("已禁用")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row flex-between"
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticClass: "row flex-start font12"
  }, [_c('el-pagination', {
    staticStyle: {
      "margin": "20px 0 20px 0"
    },
    attrs: {
      "background": "",
      "layout": "total,sizes,prev, pager, next",
      "page-size": _vm.recoData.recParams.page_size,
      "page-sizes": [10, 20, 30, 40, 50, 100, 200, 500, 1000, 2000],
      "total": _vm.recoData.total,
      "popper-class": "select_bottom"
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    },
    model: {
      value: (_vm.recoData.recParams.page_size),
      callback: function($$v) {
        _vm.$set(_vm.recoData.recParams, "page_size", $$v)
      },
      expression: "recoData.recParams.page_size"
    }
  })], 1)])], _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.show01,
      "close-on-click-modal": false,
      "append-to-body": "true"
    },
    on: {
      "update:visible": function($event) {
        _vm.show01 = $event
      },
      "closed": _vm.handleClose
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.recoData.currentRowId ? '车牌号(车牌号码不允许修改录错了请禁用)' : '车牌号',
      "prop": "PlateNo"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.recoData.currentRowId ? true : false
    },
    model: {
      value: (_vm.form.PlateNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "PlateNo", $$v)
      },
      expression: "form.PlateNo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "车辆皮重",
      "prop": "VehicleWeight"
    }
  }, [_c('el-input', {
    attrs: {
      "onkeyup": "value=value.replace(/[^\\d^\\.]+/g,'')"
    },
    model: {
      value: (_vm.form.VehicleWeight),
      callback: function($$v) {
        _vm.$set(_vm.form, "VehicleWeight", $$v)
      },
      expression: "form.VehicleWeight"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "驾驶员",
      "prop": "Driver"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.Driver),
      callback: function($$v) {
        _vm.$set(_vm.form, "Driver", $$v)
      },
      expression: "form.Driver"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "驾驶员手机",
      "prop": "DriverPhone"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.DriverPhone),
      callback: function($$v) {
        _vm.$set(_vm.form, "DriverPhone", $$v)
      },
      expression: "form.DriverPhone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属客户",
      "prop": "CarOwner"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择所属客户"
    },
    model: {
      value: (_vm.form.CarOwner),
      callback: function($$v) {
        _vm.$set(_vm.form, "CarOwner", $$v)
      },
      expression: "form.CarOwner"
    }
  }, _vm._l((_vm.CarOwnerList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.begindate),
      callback: function($$v) {
        _vm.$set(_vm.form, "begindate", $$v)
      },
      expression: "form.begindate"
    }
  }), _vm._v(" ~\n                        "), _c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.enddate),
      callback: function($$v) {
        _vm.$set(_vm.form, "enddate", $$v)
      },
      expression: "form.enddate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.Comment),
      callback: function($$v) {
        _vm.$set(_vm.form, "Comment", $$v)
      },
      expression: "form.Comment"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.show01 = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), (_vm.title == '新增车辆') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.editFuc('NEW')
      }
    }
  }, [_vm._v("确 定")]) : _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.editFuc()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-148a08cf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Car.vue
// module id = 1078
// module chunks = 1